import React from 'react';
import PropTypes from 'prop-types';
import redMask from '../../public/images/icons/redMask.svg';
import greyMask from '../../public/images/icons/greyMask.svg';

const MaskIcon = ({ isRed, className }) => <img src={isRed ? redMask : greyMask} className={className} alt="mask" />;

MaskIcon.propTypes = {
  isRed: PropTypes.bool,
  className: PropTypes.string,
};

export default MaskIcon;
